import { boxValidate } from '../../application/dtos/box_validate'

export class boxEntity {
    constructor({id, name, length, width, height, volumetricWeight, units}){
        this.id = id;
        this.length = length;
        this.name = name;
        this.width = width;
        this.height = height;
        this.volumetricWeight = volumetricWeight;
        this.units = units;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return boxValidate(this);
    }
}